import { useQuery } from 'react-query';
import { AppConfig, FhirBundlePatient, urlUtils } from '@oh-vcp/components-common';
import { apiGet } from './apiService';

const fetchSmartOnFhirPatientDetails = async (patientGuid: string): Promise<FhirBundlePatient> => {
  return apiGet(`${AppConfig.baseSofLaunchUrl}/fhir/Patient?_id=${patientGuid}`);
};

const useSmartOnFhirPatientDetails = (patientGuid: string | undefined) => {
  return useQuery({
    enabled: !!patientGuid,
    refetchOnWindowFocus: false,
    retry: 0,
    queryFn: () => fetchSmartOnFhirPatientDetails(patientGuid!),
    queryKey: ['useSmartOnFhirPatientDetails', patientGuid]
  });
};

export default useSmartOnFhirPatientDetails;
